<script setup lang="ts">
import { useThemeStore } from './stores/theme'
import { useUserStore } from './stores/user'

const { isDark } = storeToRefs(useThemeStore())
onMounted(async () => {
  await useUserStore().initializeAuth()
})
</script>

<template>
  <Toaster :theme="isDark ? 'dark' : 'light'" rich-colors />
  <RouterView />
</template>
